import { Action } from '@ngrx/store';

import { RecipeFormValues } from '@ordersnproducts/modules/order-builder/modules/retail-specification/models/form-values';

export enum ActionTypes {
  ADD_SNAPSHOT = '[RMS Open Platform Form Snapshot] Add Snapshot',
  UPDATE_SNAPSHOT = '[RMS Open Platform Form Snapshot] Update Snapshot',
  CLEAN_SNAPSHOT = '[RMS Open Platform Form Snapshot] Clean Snapshot',
  CLEAN_ALL_SNAPSHOTS = '[RMS Open Platform Form Snapshot] Clean All Snapshots',
}

export class AddSnapshot implements Action {
  readonly type = ActionTypes.ADD_SNAPSHOT;
  constructor(public payload: { formIndex: number; formSnapshot: RecipeFormValues }) {}
}

export class UpdateSnapshot implements Action {
  readonly type = ActionTypes.UPDATE_SNAPSHOT;
  constructor(public payload: { formIndex: number; formSnapshot: RecipeFormValues }) {}
}

export class CleanSnapshot implements Action {
  readonly type = ActionTypes.CLEAN_SNAPSHOT;
  constructor(public payload: { formIndex: number }) {}
}

export class CleanAllSnapshots implements Action {
  readonly type = ActionTypes.CLEAN_ALL_SNAPSHOTS;
  constructor() {}
}

export type Actions = AddSnapshot | UpdateSnapshot | CleanSnapshot | CleanAllSnapshots;
